import actionTypes from '../actionTypes';

export const getDeals = () => ({
  type: actionTypes.DEALS_GET_REQUEST,
});

export const getUserDeals = (userId) => ({
  type: actionTypes.DEALS_USER_GET_REQUEST,
  userId,
});

export const getDeal = (dealId) => ({
  type: actionTypes.DEAL_GET_REQUEST,
  dealId,
});

export const selectDeal = (deal) => ({
  type: actionTypes.DEAL_SELECT,
  deal,
});

export const createDeal = (deal) => ({
  type: actionTypes.DEAL_CREATE_REQUEST,
  deal,
});

export const updateDeal = (dealId, deal) => ({
  type: actionTypes.DEAL_UPDATE_REQUEST,
  dealId,
  deal,
});

export const deleteDeal = (dealId) => ({
  type: actionTypes.DEAL_DELETE_REQUEST,
  dealId,
});

export const getDealChanges = (dealId) => ({
  type: actionTypes.DEAL_CHANGES_GET_REQUEST,
  dealId,
});

export const getDealChange = (dealChange) => ({
  type: actionTypes.DEAL_CHANGE_GET_REQUEST,
  dealChange,
});

export const createDealChange = (dealChange) => ({
  type: actionTypes.DEAL_CHANGE_CREATE_REQUEST,
  dealChange,
});

export const updateDealChange = (dealChange) => ({
  type: actionTypes.DEAL_CHANGE_UPDATE_REQUEST,
  dealChange,
});

export const deleteDealChange = (dealChange) => ({
  type: actionTypes.DEAL_CHANGE_DELETE_REQUEST,
  dealChange,
});

export const getFinalizedDeals = (id) => ({
  type: actionTypes.FINALIZED_DEALS_GET_REQUEST,
  id,
});

export const notifyDealChange = (dealChange) => ({
  type: actionTypes.DEAL_CHANGE_NOTIFY_REQUEST,
  dealChange,
});

export const sendEmailToInviteeDealChange = (data) => ({
  type: actionTypes.DEAL_INVITEE_CHANGE_EMAIL_REQUEST,
  data,
});



// WEBPACK FOOTER //
// src/redux/actions/deals.js